import React, { createContext, useContext, useState, useEffect } from "react";
import { jwtDecode } from "jwt-decode";
import { login as loginApi } from "../api/authApi";
import { logout as logoutApi } from "../api/authApi"; // ⬅️ เพิ่ม
const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  // ✅ ตรวจว่า token หมดอายุหรือยัง
  const isTokenExpired = (token) => {
    try {
      const decoded = jwtDecode(token);
      const currentTime = Date.now() / 1000; // วินาที
      return decoded.exp < currentTime;
    } catch (err) {
      return true; // ถ้า decode ไม่ได้ ให้ถือว่า expired
    }
  };

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const username = localStorage.getItem("username");

    if (token && username) {
      if (isTokenExpired(token)) {
        logout(); // 🔥 หมดอายุ → logout เลย
      } else {
        setUser({ username });
      }
    }

    setLoading(false);
  }, []);

  useEffect(() => {
    const token = localStorage.getItem("access_token");
    const username = localStorage.getItem("username");

    if (token && username) {
      if (isTokenExpired(token)) {
        logout(); // 🔥 หมดอายุ → logout เลย
      } else {
        // ✅ Log เวลาที่เหลือ
        try {
          const decoded = jwtDecode(token);
          const currentTime = Date.now() / 1000; // วินาที
          const secondsLeft = decoded.exp - currentTime;
          const daysLeft = Math.floor(secondsLeft / 86400);
          const hoursLeft = Math.floor((secondsLeft % 86400) / 3600);
          const minutesLeft = Math.floor((secondsLeft % 3600) / 60);

          console.log(
            `⏳ Token จะหมดอายุใน ${daysLeft} วัน ${hoursLeft} ชั่วโมง ${minutesLeft} นาที`
          );
        } catch (err) {
          console.warn("⚠️ ไม่สามารถ decode token ได้");
        }

        setUser({ username });
      }
    }

    setLoading(false);
  }, []);

  const login = async (username, password) => {
    const res = await loginApi(username, password);
    localStorage.setItem("access_token", res.token);
    localStorage.setItem("username", res.username);
    setUser({ username: res.username });
  };

  const logout = async () => {
    try {
      await logoutApi(); // ⬅️ เรียก API ไปลบ session
    } catch (err) {
      console.warn("Logout failed (maybe already expired):", err.message);
    } finally {
      localStorage.removeItem("access_token");
      localStorage.removeItem("username");
      setUser(null);
    }
  };

  return (
    <AuthContext.Provider value={{ user, login, logout }}>
      {!loading && children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
